'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (layout, el, dashboard) {
    return _extends({}, (0, _type2.default)(layout.type), { renderTo: el || layout.el }, DEFAULT_CHART, dashboard ? DASHBOARD_CHART : undefined);
};

var _type = require('./type');

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_CHART = {
    fontFamily: 'Helvetica Neue,Helvetica,Arial,sans-serif !important',
    spacingTop: 20
};

var DASHBOARD_CHART = {
    spacingTop: 0,
    spacingRight: 5,
    spacingBottom: 2,
    spacingLeft: 5
};

;
//# sourceMappingURL=chart.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/chart.js
 ** module id = 237
 ** module chunks = 0 1
 **/